/**
 * @generated SignedSource<<8fcb93d756ea9cf1bf96f716390ecfea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BuildTypeChainBlockQuery$variables = {
  locator: string;
};
export type BuildTypeChainBlockQuery$data = {
  readonly buildTypes: {
    readonly buildType: ReadonlyArray<{
      readonly rawId: string | null;
    }> | null;
  } | null;
};
export type BuildTypeChainBlockQuery = {
  response: BuildTypeChainBlockQuery$data;
  variables: BuildTypeChainBlockQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "locator",
    "variableName": "locator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BuildTypeChainBlockQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BuildTypes",
        "kind": "LinkedField",
        "name": "buildTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BuildTypeRest",
            "kind": "LinkedField",
            "name": "buildType",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BuildTypeChainBlockQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BuildTypes",
        "kind": "LinkedField",
        "name": "buildTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BuildTypeRest",
            "kind": "LinkedField",
            "name": "buildType",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cec0caab545565a90553295788d2b086",
    "id": null,
    "metadata": {},
    "name": "BuildTypeChainBlockQuery",
    "operationKind": "query",
    "text": "query BuildTypeChainBlockQuery(\n  $locator: String!\n) {\n  buildTypes(locator: $locator) {\n    buildType {\n      rawId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "acecc11799ecabad792b6b5b254d4e87";

export default node;
